import style from './formCompoStyle.module.css';
const FormValidationCompo = () => {
  return (
    <div>
      <div className="container mb-5">
        <div className="row">
          <div className="col-md-12 col-lg-12 col-xl-12">
            <form className={style.form}>
              <div className="mb-3">
                <label for="name" className={`form-label ${style.label}`}>
                  {' '}
                  Nama{' '}
                </label>
                <input
                  type="text"
                  className={`form-control rounded-3  ${style.input}`}
                />
              </div>
              <div className="mb-3">
                <label
                  for="exampleInputEmail1"
                  className={`form-label ${style.label}`}
                >
                  Email address
                </label>
                <input
                  type="email"
                  className={`form-control rounded-3 ${style.input}`}
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
              <div className="mb-3">
                <label for="No Hp" className={`form-label ${style.label}`}>
                  {' '}
                  No Hp{' '}
                </label>
                <input
                  type="tel"
                  className={`form-control rounded-3 ${style.input}`}
                />
              </div>
              <div className="mb-3">
                <label
                  for="ttl"
                  className={`form-label rounded-3 ${style.label}`}
                >
                  {' '}
                  Tanggal Lahir{' '}
                </label>
                <input
                  type="text"
                  className={`form-control rounded-3 ${style.input}`}
                />
              </div>
              <div className="mb-3">
                <label
                  for="name"
                  className={`form-label rounded-3 ${style.label}`}
                >
                  {' '}
                  Foto KTP{' '}
                </label>
                <span className={`${style.iconFile1} text-center`}>
                  <div className={`col d-flex flex-column ${style.iconKTP}`}>
                    <img
                      src={require('../../assets/images/akar-icons_image.png')}
                      alt=""
                      className={style.img}
                    />
                    <p className="mt-2">Upload Foto KTP</p>
                  </div>
                </span>
                <input
                  type="file"
                  className={`form-control rounded-3 ${style.fileInput} ${style.input}`}
                />
              </div>
              <div className="mb-3">
                <label for="name" className={`form-label ${style.label}`}>
                  {' '}
                  Upload CV{' '}
                </label>
                <span className={`${style.iconFile2} text-center`}>
                  <div className={`col d-flex flex-column ${style.iconCV}`}>
                    <img
                      src={require('../../assets/images/akar-icons_image.png')}
                      alt=""
                      className={style.img}
                    />
                    <p className="mt-2">Upload CV</p>
                  </div>
                </span>
                <input
                  type="file"
                  className={`form-control  rounded-3 ${style.fileInput} ${style.input}`}
                />
              </div>

              <button
                type="submit"
                className={`btn btn-success btn-lg ${style.tombol}`}
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormValidationCompo;
